import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unabbreviateEmploymentStatus'
})
export class UnabbreviateEmploymentStatusPipe implements PipeTransform {

  transform(abbreviatedStatus: string): string {
    switch(abbreviatedStatus) {
      case "RFT": return "Regular full-time";
      case "RPT": return "Regular part-time";
      case "TFT": return "Temporary full-time";
      case "AUX": return "Auxiliary";
      default:
        return "";
    }
  }

}
